<template>
  <!-- 1): 전체 페이지 -->
  <div class="detail" :id="data.summary">
    <h1 class="title detail-sutxt">
      <span>{{ data.summary }}</span>
    </h1>

    <!-- 2) 컴포넌트 큰 틀(초록, 파랑 바뀌는 고) -->
    <div
        class="contents"
        :class="{
        contentsGet: dataMethod === 'get',
        contentsPost: dataMethod === 'post',
        contentsPut: dataMethod === 'put',
        contentsDelete: dataMethod === 'delete',
      }"
    >
      <!-- 3) get, post 및 주소 써있는 거 -->
      <div
          class="contents__summary"
          :class="{
          bottomGet: dataMethod === 'get',
          bottomPost: dataMethod === 'post',
          bottomPut: dataMethod === 'put',
          bottomDelete: dataMethod === 'delete',
        }"
      >
        <span
            class="methodBox"
            :class="{
            methodBoxGet: dataMethod === 'get',
            methodBoxPost: dataMethod === 'post',
            methodBoxPut: dataMethod === 'put',
            methodBoxDelete: dataMethod === 'delete',
          }"
        >{{ dataMethod }}</span
        >
        <span class="path">{{ `https://api.directcloud.jp${dataUrl}` }}</span>
        <div class="description">{{ data.summary }}</div>
      </div>
      <!-- 3) -->

      <!-- 4) 3아래 부분들 (description, parameters 등) -->
      <div class="contents__descriptions">
        <!-- 5) description (md 쓴 거)  -->
        <div class="way">
          <div
              class="way__description"
              v-html="converted(this.data.description)"
          />
        </div>
        <!-- 5) -->

        <!-- 6) parameters 부분 -->
        <div class="section">
          <div class="section__header">
            <span>Parameters</span>
            <div class="header__button">
              <button class="button__try-out" style="display: none">
                Try it out
              </button>
            </div>
          </div>

          <div class="section__param">
            <div v-if="this.parameters">
              <parameter-component :params="params"/>
            </div>
            <div v-else>
              <p>No parameters</p>
            </div>
          </div>
        </div>
        <!-- 6) -->

        <!--  requestBody      -->
        <div class="section" v-if="this.data.requestBody">
          <div class="section__header">
            <span>
              RequestBody
              <div class="data__type">
                {{ this.dataType }}
                <!--                <span v-if="this.dataType !== 'application/json'">※application/jsonでの指定も可能です。</span>-->
              </div>
            </span>
          </div>
          <requestbody-component :requests="requests"></requestbody-component>
        </div>
        <!--  requestBody      -->

        <!-- 7) responses 부분 -->
        <div class="section">
          <div class="section__header">
            <span>Responses</span>
          </div>
          <Response :data="data" :responses="responses"></Response>
          <!--          <response-component :data="data" />-->
        </div>
        <!-- 7) -->
      </div>
      <!-- 4) -->
    </div>
    <!-- 2) -->
  </div>
  <!-- 1) -->
</template>

<script>
// Components
import ParameterComponent from './ParameterComponent';
import ResponseComponent from './ResponseComponent';
import RequestbodyComponent from './RequestbodyComponent';
import Response from './Response';

// Functions
import MarkdownIt from 'markdown-it';
import {refParser} from '../data/userData';

// Files
import parametersFile from '../data/document/parameters.yaml';
import requestsFile from '../data/document/openapi/requests.yaml';

export default {
  name: 'DetailComponent',
  components: {
    ParameterComponent,
    ResponseComponent,
    Response,
    RequestbodyComponent,
  },
  props: {
    data: Object,
    dataMethod: String,
    dataUrl: String,
    parameters: Array,
    title: String,
  },
  methods: {
    converted(description) {
      const md = new MarkdownIt();

      // 아래 라인은 markDown 의 Link 에 target='_blank' 를 추가함
      const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
        return self.renderToken(tokens, idx, options);
      };
      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        tokens[idx].attrSet('target', '_blank');
        return defaultRender(tokens, idx, options, env, self);
      };

      let converted = md.render(description);
      converted = converted.replaceAll('&lt;br&gt;', '<br>');
      return converted;
    },
  },
  data: function () {
    return {
      dataType: '',
    };
  },
  computed: {
    params() {
      if (!this.parameters) return;
      return refParser(parametersFile, this.parameters);
    },
    requests() {
      if (!this.data.requestBody) return;
      // webhook 제외.
      if ('$ref' in this.data.requestBody) {
        this.data.requestBody = refParser(requestsFile, this.data.requestBody);
      }
      // webhook
      const content = this.data.requestBody.content;
      const keys = Object.keys(content);
      this.dataType = keys[0];
      return content[keys[0]];
    },
    responses() {
      if (!this.data.responses) return;
      return this.data.responses;
    },
  },
};
</script>

<style scoped lang="scss">
.detail {
  // main 컨테이너
  padding: 0 1.4rem;
  font-family: Meiryo, sans-serif;
}

.detail-sutxt {
  font-size: 23px;
  color: rgb(21, 31, 38);
  padding-top: 35px;
  line-height: 1.1;
}

.contents {
  // root contents 컨테이너
  border-radius: 4px;

  .contents__summary {
    // 컨텐츠의 요약 컨테이너
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;

    .methodBox {
      // 요약 컨테이너의 전송방식
      font-size: 14px;
      font-weight: 700;
      min-width: 40px;
      padding: 6px 15px;
      text-align: center;
      border-radius: 3px;
      background: #61affe;
      text-shadow: 0 1px 0 rgb(0 0 0 / 10%);
      font-family: sans-serif;
      color: #fff;
    }

    .methodBoxGet {
      background: #61affe;
      color: #fff;
    }

    .methodBoxPost {
      background: #49cc90;
      color: #fff;
    }

    .methodBoxPut {
      background: #95507c;
      color: #ffffff;
    }

    .methodBoxDelete {
      background: #cc3333;
      color: #ffffff;
    }

    .path {
      // 요약 컨테이너의 url
      font-size: 14px;
      display: flex;
      align-items: center;
      word-break: break-word;
      padding: 0 10px;
      font-family: monospace;
      font-weight: 600;
      color: #3b4151;
    }

    .description {
      // 요약 컨테이너의 설명
      display: flex;
      align-items: center;
      padding: 5px;
      cursor: pointer;
    }
  }

  .contents__descriptions {
    // 컨텐츠의 사용방법 컨테이너
    font-size: 12px;
    font-family: Meiryo, sans-serif;
    color: #3b4151;

    .way,
    .section__param,
    .section__response {
      margin: 0 0 5px;
      padding: 15px 20px;

      .way__description {
        ::v-deep h3 {
          font-weight: 800;
        }

        ::v-deep code {
          padding: 5px 7px;
          font-size: 10px;
          font-weight: 600;
          border-radius: 4px;
          background: #dfe7ee;
          color: #9012fe;
        }

        ::v-deep table {
          border: 1px solid black;
          border-collapse: collapse;
        }

        ::v-deep th {
          border: 1px solid black;
          border-collapse: collapse;
        }

        ::v-deep td {
          border: 1px solid black;
          border-collapse: collapse;
        }
      }
    }

    .section {
      .section__header {
        // 파라메터 컨테이너의 타이틀
        display: flex;
        align-items: center;
        padding: 8px 20px;
        min-height: 20px;
        background: #fbfdfe;
        box-shadow: 0 1px 2px rgb(0 0 0 / 10%);

        span {
          font-size: 14px;
          font-weight: 600;
          display: flex;
          flex: 1;
        }

        .header__button {
          .button__try-out {
            font-size: 12px;
            font-weight: 700;
            padding: 5px 15px;
            transition: all 0.3s;
            border: 2px solid grey;
            border-radius: 4px;
            background: transparent;
            box-shadow: 0 1px 2px rgb(0 0 0 / 10%);
            color: #3b4151;
          }
        }
      }

      .mediaType {
        display: block;
        margin-bottom: 0.2em;
        font-size: 0.7em;
      }

      .acceptMessage {
        display: block;
        color: green;
        font-size: 0.7em;
      }

      .data__type {
        text-indent: 15px;
        color: grey;
        font-size: 0.8em;
        font-weight: lighter;
      }
    }
  }
}

.bottomGet {
  border-bottom: 2px #60adfb solid;
}

.bottomPost {
  border-bottom: 2px #49cc90 solid;
}

.bottomPut {
  border-bottom: 2px #95507c solid;
}

.bottomDelete {
  border-bottom: 2px #cc3333 solid;
}

.contentsGet {
  background-color: #ebf3fb;
  border: 2px #60adfb solid;
}

.contentsPost {
  background-color: #eeffee;
  border: 2px #49cc90 solid;
}

.contentsPut {
  background-color: #fffafa;
  border: 2px #95507c solid;
}

.contentsDelete {
  background-color: #fff5ee;
  border: 2px #cc3333 solid;
}
</style>
